<template>
<div id="protocol-setup">
  <h2 id="setup" class="offset">Setup</h2>
  <div class="setup">
  <div id="deck-list">

  <h3>Deck Map</h3>

  <h4>Containers</h4>
  <ul class="containers">
    <li v-for='container in containers'>
    [<a @mouseenter="activateContainer(container.slot)" @mouseout="deactivateContainers()">{{ container.slot }}</a>] {{ container.name }} ({{ container.type }})
    </li>
  </ul>

  <h4>Pipettes</h4>
    <ul class="instruments">
      <li v-for='instrument in instruments'>
        {{ instrument.name }} {{ instrument.type }} ({{ axis(instrument.axis) }})
      </li>
    </ul>
  <h3 id="reagents">Reagents</h3>
    <div v-html="makeHtml('reagents')" class="reagents"></div>

  </div>
  <div id="deck-map">
    <div class="deck">
      <div class="content">
      <div v-for="col in columns" class="deck-col">
        <div v-for="row in rows" class="deck-slot" :id="col+row" v-bind:class="{ occupied: hasContainer(col+row)}">
            <Container v-if="hasContainer(col+row)" :placeable="getContainer(col+row)" :class="{active : isActive(col+row)}"></Container>
            <div class="empty" v-else ><p>{{col+row}}</p></div>
       </div>
      </div>
    </div>
  </div>
  </div>
  </div>
</div>
</div>
</template>

<script>
  import showdown from 'showdown'
  import Container from './Container'

  export default {
    name: 'Setup',
    props: ['protocol'],
    components: {
      Container
    },
    data () {
      return {
        markdown: this.protocol.markdown,
        containers: this.protocol.containers,
        instruments: this.protocol.instruments,
        rows: [1, 2, 3],
        columns: ['A', 'B', 'C', 'D', 'E'],
        selected: null
      }
    },
    methods: {
      makeHtml (key) {
        let markdownText = this.protocol.markdown ? this.protocol.markdown[key] : ''
        return new showdown.Converter().makeHtml(markdownText)
      },
      occupiedSlots () {
        let slots = this.containers.map((c) => {
          return c['slot']
        })
        return slots
      },
      hasContainer (slot) {
        return this.occupiedSlots().includes(slot)
      },
      getContainer (slot) {
        let container = this.containers.find(element => element.slot === slot)
        return container
      },
      activateContainer (slot) {
        let activeContainer = this.getContainer(slot)
        this.selected = activeContainer.slot
      },
      deactivateContainers () {
        this.selected = null
      },
      isActive (slot) {
        return slot === this.selected
      },
      axis (axis) {
        if (axis === 'a') {
          return 'center'
        } else {
          return 'left'
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Setup.vue?25623e3c